<div class="main-content table-page table-page--compact incidencias-board-page incidencias-ia-page">
  <div class="container-fluid">
    <section class="table-page__card">
      <div class="incidencias-board-page__toolbar-anchor">
        <div class="table-page__toolbar table-page__toolbar--filters">
          <div class="table-page__filters-grid incidencias-board-page__filters-grid"></div>

          <div class="incidencias-board-page__toolbar-actions">
            <label class="table-page__page-size incidencias-board-page__page-size">
              <span>Registros</span>
              <select [ngModel]="itemsPerPage" (ngModelChange)="onItemsPerPageChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
              </select>
            </label>

            <button
              type="button"
              mat-raised-button
              class="btn table-page__icon-btn incidencias-board-page__toolbar-btn"
              (click)="abrirAlta()">
              <i class="material-icons">add</i>
              <span>Nueva</span>
            </button>

            <button
              type="button"
              mat-raised-button
              class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-board-page__toolbar-btn"
              (click)="refrescarTodas()">
              <i class="material-icons">refresh</i>
              <span>Actualizar</span>
            </button>

            <button
              type="button"
              mat-raised-button
              class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-board-page__toolbar-btn"
              (click)="filtersPopupOpen = !filtersPopupOpen">
              <i class="material-icons">tune</i>
              <span>Filtros</span>
              <strong class="incidencias-board-page__toolbar-badge" *ngIf="getActiveFiltersCount() > 0">
                {{ getActiveFiltersCount() }}
              </strong>
            </button>

            <div class="incidencias-board-page__toolbar-summary">
              <span>Total</span>
              <strong>{{ totalItems }}</strong>
            </div>
          </div>
        </div>

        <div class="alert alert-danger incidencia-ia-page__load-alert" *ngIf="errorCarga">
          <i class="material-icons">error_outline</i>
          <span>{{ errorCarga }}</span>
        </div>

        <div class="incidencias-board-page__filters-popover is-open" *ngIf="filtersPopupOpen">
          <div class="incidencias-board-page__filters-dialog">
            <div class="incidencias-board-page__filters-dialog-header">
              <div>
                <h3>Filtros de incidencias IA</h3>
                <p>Aplica búsqueda por número, fecha, responsable, gravedad o prioridad.</p>
              </div>
            </div>

            <div class="incidencias-board-page__filters-panel">
              <div class="row incidencias-ia-page__filters-grid">
                <div class="col-12 col-md-4">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>No.</mat-label>
                    <input aria-label="No." matInput type="number" min="1" [(ngModel)]="filtros.idIncidenciaIa" />
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-8">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>Rango de fecha apertura</mat-label>
                    <mat-date-range-input [rangePicker]="pickerFiltro">
                      <input aria-label="Inicio" matStartDate [(ngModel)]="filtros.fechaAperturaInicio" placeholder="Inicio" readonly />
                      <input aria-label="Fin" matEndDate [(ngModel)]="filtros.fechaAperturaFin" placeholder="Fin" readonly />
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="pickerFiltro"></mat-datepicker-toggle>
                    <mat-date-range-picker #pickerFiltro></mat-date-range-picker>
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-4">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>Notificado por</mat-label>
                    <input aria-label="Notificado por" matInput maxlength="90" [(ngModel)]="filtros.notificadoPor" />
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-4">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>Gravedad</mat-label>
                    <mat-select [(ngModel)]="filtros.gravedad">
                      <mat-option [value]="null">Todas</mat-option>
                      <mat-option *ngFor="let option of gravedadOptions" [value]="option.value">
                        {{ option.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-4">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>Prioridad</mat-label>
                    <mat-select [(ngModel)]="filtros.prioridad">
                      <mat-option [value]="null">Todas</mat-option>
                      <mat-option *ngFor="let option of prioridadOptions" [value]="option.value">
                        {{ option.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="incidencias-board-page__filters-dialog-actions">
              <button
                type="button"
                mat-raised-button
                class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-board-page__toolbar-btn"
                (click)="limpiarFiltros()">
                <i class="material-icons">filter_alt_off</i>
                <span>Limpiar</span>
              </button>
              <button
                type="button"
                mat-raised-button
                class="btn table-page__icon-btn incidencias-board-page__toolbar-btn"
                (click)="aplicarFiltros()">
                <i class="material-icons">done</i>
                <span>Aplicar</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="incidencias-board-page__board-shell">
        <div class="incidencias-board-page__board">
          <article
            class="incidencias-board-page__column"
            *ngFor="let column of columns; trackBy: trackByEstado"
            [style.--incidencia-column-color]="column.color">
            <header class="incidencias-board-page__column-header" [style.backgroundColor]="column.color">
              <div class="incidencias-board-page__column-title">
                <span class="material-icons">{{ column.icon }}</span>
                <div class="incidencias-board-page__column-title-text">
                  <strong>{{ column.titulo }}</strong>
                  <small>{{ column.totalItems }}</small>
                </div>
              </div>
            </header>

            <div class="incidencias-board-page__column-pager" *ngIf="column.totalItems > 0">
              <div class="table-page__pager incidencias-board-page__pager">
                <span class="incidencias-ia-page__pager-summary">
                  {{ column.currentPage }}/{{ column.totalPages || 1 }}
                </span>
                <button type="button" class="table-page__pager-link" (click)="firstPage(column)" [disabled]="column.currentPage <= 1">&laquo;</button>
                <button type="button" class="table-page__pager-link" (click)="previousPage(column)" [disabled]="column.currentPage <= 1">&lsaquo;</button>
                <ng-container *ngFor="let page of getPaginationItems(column)">
                  <button
                    *ngIf="isPageNumber(page); else ellipsisTpl"
                    type="button"
                    class="table-page__pager-page"
                    [class.is-current]="page === column.currentPage"
                    (click)="pageChanged(column, page)">
                    {{ page }}
                  </button>
                </ng-container>
                <ng-template #ellipsisTpl>
                  <span class="table-page__pager-ellipsis">…</span>
                </ng-template>
                <button type="button" class="table-page__pager-link" (click)="nextPage(column)" [disabled]="column.currentPage >= column.totalPages">&rsaquo;</button>
                <button type="button" class="table-page__pager-link" (click)="lastPage(column)" [disabled]="column.currentPage >= column.totalPages">&raquo;</button>
              </div>
            </div>

            <div class="incidencias-board-page__column-body">
              <div class="table-page__empty-state incidencias-ia-page__empty-column" *ngIf="!column.loading && !column.items.length">
                <mat-icon>event_busy</mat-icon>
                <p>Sin incidencias en {{ column.titulo }}.</p>
              </div>

              <button
                type="button"
                class="incidencias-ia-card"
                *ngFor="let incidencia of column.items; trackBy: trackByIncidencia"
                (click)="abrirDetalle(incidencia)">
                <span class="incidencias-ia-card__stripe" [style.backgroundColor]="column.color"></span>
                <span class="incidencias-ia-card__header">
                  <strong>#{{ incidencia.idIncidenciaIa }}</strong>
                  <small>{{ formatDate(incidencia.fechaApertura) }}</small>
                </span>
                <span class="incidencias-ia-card__title">
                  {{ incidencia.herramientaIaConsecutivo || 'IA' }} - {{ incidencia.herramientaIaNombre || 'Sin herramienta' }}
                </span>
                <span class="incidencias-ia-card__description">
                  {{ incidencia.descripcionEvento || 'Sin descripción' }}
                </span>
                <span class="incidencias-ia-card__chips">
                  <em>{{ labelPrioridad(incidencia.prioridad) }}</em>
                  <em>{{ labelGravedad(incidencia.gravedad) }}</em>
                  <em *ngIf="incidencia.nombreResponsableSeguimiento">
                    {{ incidencia.nombreResponsableSeguimiento }}
                  </em>
                </span>
                <span class="incidencias-ia-card__footer">
                  <span>{{ labelTipoEvento(incidencia.tipoEvento) }}</span>
                  <span>{{ incidencia.notificadoPor || '-' }}</span>
                </span>
              </button>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</div>
